import { FC, PropsWithChildren, ReactElement } from "react";

import { TDrawerCloseFunction } from "@ryde/shared";

import { DrawerContentStyled, DrawerHeader } from "./drawer";

export interface ICommonDefaultDrawerProps extends PropsWithChildren {
  onCloseDrawer: TDrawerCloseFunction;
  title?: string;
  className?: string;
  Header?: ReactElement;
  Footer?: ReactElement;
}

export const CommonDefaultDrawer: FC<ICommonDefaultDrawerProps> = ({
  onCloseDrawer,
  children,
  title,
  className,
  Header,
  Footer,
}) => {
  return (
    <>
      {Boolean(Header) && !title && Header}
      {title !== undefined && (
        <DrawerHeader onCloseDrawer={onCloseDrawer} title={title as string} />
      )}
      <DrawerContentStyled className={className ?? ""}>
        {children}
      </DrawerContentStyled>
      {Boolean(Footer) && Footer}
    </>
  );
};
